import React, { useEffect, useState } from "react";
import MobilePage from "../../../Components/MobilePage";
import { useHistory, useRouteMatch } from "react-router";

import PackageInstanceProvider, {
  ACTIONS_SET_ADDED_TO_CART,
  ACTIONS_SET_ADDING_TO_CART,
  ACTIONS_SET_FAILED_ADDING_TO_CART,
  usePackageInstance,
} from "../../../../Providers/PackageInstanceProvider";
import EditPackage from "../../Components/EditTemplateProduct/EditPackage";
import AppBar from "../../Components/AppBar";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import { usePortal } from "../../../../Providers/PortalProvider";
import AddPackageToCartWarningDialog from "../../Components/AddPackageToCartWarningDialog";
import { toast } from "react-toastify";

export default () => {
  return (
    <PackageInstanceProvider>
      <CreatePackage />
    </PackageInstanceProvider>
  );
};

const CreatePackage = () => {
  const { params } = useRouteMatch();
  const {
    state,
    initializeInstanceByUuid,
    loading,
    dispatch: packageDispatch,
  } = usePackageInstance();
  const { addItem } = useShoppingCart();
  const history = useHistory();
  const portal = usePortal();
  const [showAddToCartWarningDialog, setShowAddToCartWarningDialog] =
    useState(false);

  console.log("The portal", portal);

  useEffect(() => {
    initializeInstanceByUuid(params.packageUuid);
    return () => {
      //clearTemplateInstance();
    };
  }, []);

  const handleAddToCart = () => {
    if (portal.webshop.package.addToCartWarning) {
      setShowAddToCartWarningDialog(true);
    } else {
      doAddToCart();
    }
  };

  const doAddToCart = () => {
    // Make sure the dialog is closed:
    setShowAddToCartWarningDialog(false);

    packageDispatch({
      type: ACTIONS_SET_ADDING_TO_CART,
      payload: {
        isAddingToCart: true,
      },
    });
    addItem({
      package: state,
    })
      .then((data) => {
        packageDispatch({
          type: ACTIONS_SET_ADDED_TO_CART,
        });
        if (data.error) {
          packageDispatch({
            type: ACTIONS_SET_ADDING_TO_CART,
            payload: {
              isAddingToCart: false,
            },
          });
          toast.error(data.error);
        } else {
          // Don't set adding to cart complete as redirect may take some time:
          history.push("/shopping-cart");
        }
      })
      .catch((err) => {
        packageDispatch({
          type: ACTIONS_SET_FAILED_ADDING_TO_CART,
          payload: {
            error: err,
          },
        });
      });
    return;
  };

  if (loading) {
    return <div>Loading</div>;
  }

  return (
    <MobilePage>
      <AppBar />

      <EditPackage mode={"create"} handleUpdateCart={handleAddToCart} />
      {showAddToCartWarningDialog && (
        <AddPackageToCartWarningDialog
          handleCancel={() => setShowAddToCartWarningDialog(false)}
          handleAddToCart={doAddToCart}
        />
      )}
    </MobilePage>
  );
};
